import styled from 'styled-components';
import MuiBox from '@material-ui/core/Box';

export const Container = styled.div`
  position: relative;
  padding: 12px 24px;
  max-width: 1110px;
  margin: 0 auto;
`;

export const Flex = styled(MuiBox)`
  display: flex;
  flex-direction: row;
`;

export const Box = styled(MuiBox)`
  position: relative;
`;
